import { omit } from "lib/omit"
import { stringifyStandardTaskComparisonValue } from "routes/schedule/compare/lib/task-comparison-normalization.mjs"
import { getComparisonNormalizeString } from "routes/schedule/compare/get-comparison-normalizer"

function compareNormalizedProperties(item, normalizeString) {
    return stringifyStandardTaskComparisonValue(item, {
        ignoreDollarKeys: true,
        normalizeString,
    })
}

export function checkTaskEquality(t1, t2) {
    const normalizeString = getComparisonNormalizeString(t1, t2)
    return (
        compareNormalizedProperties(omit(t1, "skill", "index"), normalizeString) ===
        compareNormalizedProperties(omit(t2, "skill", "index"), normalizeString)
    )
}
